/* @flow */
import React from 'react';
import cx from 'classnames';
import ConnectedBankAccount from 'entities/ConnectedBankAccount';
import ManagerItemCard from './ManagerItemCard.jsx';
import ToastActions from 'actions/ToastActions';
import Button from 'components/Button.jsx';
import Image from 'components/Image.jsx';
import Text from 'components/Text.jsx';
import API from 'lib/RemindAPI';

import './styles/SchoolBankAccountsPendingItem.scss';

export default class SchoolBankAccountsPendingItem extends React.Component {
  static propTypes = {
    connectedBankAccount: React.PropTypes.instanceOf(ConnectedBankAccount).isRequired,
  }

  invite = () => {
    const { id } = this.props.connectedBankAccount;
    API.request(`/payments/connected_bank_accounts/${id}/resend_request`, 'POST').then(() => {
      ToastActions.showSuccessToast('Invitation sent');
    }, (error) => {
      if (error && error.code === 'throttling_error') {
        ToastActions.showErrorToast('Oops, you can only reinvite once per day.');
      } else {
        ToastActions.showErrorToast('Oops, an unknow error happened.');
      }
    });
  }

  render() {
    const { connectedBankAccount } = this.props;
    const organizationName = connectedBankAccount.getOrganizationName();

    return (
      <ManagerItemCard className={cx('SchoolBankAccountsPendingItem', this.props.className)}>
        <div className="SchoolBankAccountsPendingItem-content">
          <div className="SchoolBankAccountsPendingItem-info">
            <Image
              className="SchoolBankAccountsPendingItem-image"
              src={require('assets/images/payments/school-bank-account.svg')}
            />
            <div>
              <div className="SchoolBankAccountsPendingItem-title">
                <Text size="large">
                  {organizationName || connectedBankAccount.getOwnerName()}
                </Text>
              </div>
              <div>
                <Text color="sunrise">
                  Pending deposit approval
                </Text>
              </div>
              <div>
                <div>
                  <Text
                    size="xsmall"
                    className="SchoolBankAccountsPendingItem-label"
                    color="thunder">
                    Account admin name:
                  </Text>
                  <Text size="xsmall" color="thunder">
                    {connectedBankAccount.getOwnerName()}
                  </Text>
                </div>
                <div>
                  <Text
                    size="xsmall"
                    className="SchoolBankAccountsPendingItem-label"
                    color="thunder">
                    Account admin email:
                  </Text>
                  <Text size="xsmall" color="thunder">
                    {connectedBankAccount.getOwnerAddress()}
                  </Text>
                </div>
              </div>
            </div>
          </div>
          <div>
            <Button color="sunrise" onClick={this.invite} level="secondary" size="small">
              Reinvite
            </Button>
          </div>
        </div>
      </ManagerItemCard>
    );
  }
}



// WEBPACK FOOTER //
// ./src/payments/components/SchoolBankAccountsPendingItem.jsx